
import styles from './CardAnswer.module.css';

const CardAnswer = ({ checked, nextQuestionHandler, value, title, id }) => {

    return (
        <div key={id}
            className={`${styles.card}
        ${checked ? styles.selected : null}
        `}
            onClick={() => nextQuestionHandler(value)}>
            <img style={{ height: '50px', width: '50px' }} src="https://cdn-icons-png.flaticon.com/512/858/858170.png" alt="Avatar" />
            <div className="container">
                <h4><b>{title}</b></h4>
            </div>
        </div>
    )
}

export default CardAnswer